var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_c('img',{staticClass:"title-l",attrs:{"src":require("@/assets/result/title_l.png")}}),_vm._t("default"),_c('img',{staticClass:"title-r",attrs:{"src":require("@/assets/result/title_r.png")}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }